import { graphql, readInlineData } from 'react-relay';

import { GRAPHQL_TYPE } from '@woovi/shared';

import type { useGraphQLType_query$key } from './__generated__/useGraphQLType_query.graphql.ts';

export const useGraphQLType = (queryRef: useGraphQLType_query$key) => {
  const query = readInlineData<useGraphQLType_query$key>(
    graphql`
      fragment useGraphQLType_query on Query @inline {
        graphqlType
      }
    `,
    queryRef,
  );

  return {
    isGraphQLMain: query.graphqlType === GRAPHQL_TYPE.GRAPHQL,
    isGraphQLLink: query.graphqlType === GRAPHQL_TYPE.LINK,
    isGraphQLOpenPix: query.graphqlType === GRAPHQL_TYPE.OPEN_PIX,
  };
};
